export const ROLE_VIEWS = [
  { key: "executive", label: "Executive", to: "/views/executive" },
  { key: "operations", label: "Operations", to: "/views/operations" },
  { key: "compliance", label: "Compliance", to: "/views/compliance" },
  { key: "journey", label: "Client Journey", to: "/views/journey" },
  { key: "technical", label: "Technical", to: "/views/technical" },
];
